import { Handler, WildcardHandler } from "mitt";
import { BaseEventEmitter } from "./baseEventEmitter";
import { AllEvents, AllContexts } from "./allEvents";
import { EventsWithContext } from "./types";

export class GlobalEventBus extends BaseEventEmitter<AllEvents, AllContexts> {
  private static instance: GlobalEventBus;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!GlobalEventBus.instance) {
      GlobalEventBus.instance = new GlobalEventBus();
    }

    return GlobalEventBus.instance;
  }

  on<Key extends keyof AllEvents | "*">(
    type: Key,
    handler: Key extends "*"
      ? WildcardHandler<EventsWithContext<AllEvents, AllContexts>>
      : Handler<EventsWithContext<AllEvents, AllContexts>[Extract<Key, keyof AllEvents>]>
  ) {
    return super.on(type, handler);
  }

  off<Key extends keyof AllEvents | "*">(
    type: Key,
    handler: Key extends "*"
      ? WildcardHandler<EventsWithContext<AllEvents, AllContexts>>
      : Handler<EventsWithContext<AllEvents, AllContexts>[Extract<Key, keyof AllEvents>]>
  ) {
    return super.off(type, handler);
  }

  static resetInstance() {
    GlobalEventBus.instance = new GlobalEventBus();
    return GlobalEventBus.instance;
  }
}

export let globalEventBus = GlobalEventBus.getInstance();

export function resetGlobalEventBus() {
  globalEventBus = GlobalEventBus.resetInstance();
}
